var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouseLaptop = function SvgHouseLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.025 4.169a.75.75 0 0 1 .947 0l6.75 5.5a.75.75 0 1 1-.95 1.162L15 10.2v1.3h-1.5V8.978l-4-3.26-4 3.26v6.272c0 .137.113.25.25.25h4.75V17H5.75C4.784 17 4 16.216 4 15.25V10.2l-.775.631a.753.753 0 0 1-1.056-.106.753.753 0 0 1 .106-1.056zM11 10.75v1.428a2 2 0 0 0-.416.744.75.75 0 0 1-.334.078h-1.5a.75.75 0 0 1-.75-.75v-1.5c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75M13 14v4.5h6V14zm-1.5-.5c0-.553.447-1 1-1h7c.553 0 1 .447 1 1v5h1.125c.206 0 .375.169.375.375 0 .622-.503 1.125-1.125 1.125h-9.75A1.124 1.124 0 0 1 10 18.875c0-.206.169-.375.375-.375H11.5z"
  })));
};
export default SvgHouseLaptop;